import type { UseCategoryFormsArgs } from '@/types/category';

import { ADD, CLOSED } from '@/constants';
import { useCategoryMutations } from '@/hooks/api/use-category-mutations';
import { getCategoryFormConditionalProps, parseEditingCategoryId } from '@/lib/helpers/categories';

export { useCategoryMutations } from '@/hooks/api/use-category-mutations';

export function useCategoryForms({
  selectedCategoryId,
  onSelectCategoryId,
  categories,
  categoryForm,
  setCategoryForm,
}: UseCategoryFormsArgs) {
  const { deleteCategory, openEditCategory } = useCategoryMutations({
    selectedCategoryId,
    onSelectCategoryId,
    categoryForm,
    setCategoryForm,
  });

  const showCategoryForm = categoryForm !== CLOSED;
  const editingCategoryId = parseEditingCategoryId(categoryForm);
  const editingCategory = editingCategoryId
    ? categories.find(({ id }) => id === editingCategoryId)
    : null;

  function openAddCategoryForm() {
    setCategoryForm(CLOSED);
    setCategoryForm(ADD);
  }

  function closeCategoryForm() {
    setCategoryForm(CLOSED);
  }

  const categoryFormConditionalProps = getCategoryFormConditionalProps(
    categoryForm,
    editingCategoryId,
    editingCategory ?? null
  );

  return {
    showCategoryForm,
    categoryFormEditingId: editingCategoryId,
    categoryFormConditionalProps,
    openAddCategoryForm,
    closeCategoryForm,
    deleteCategory,
    openEditCategory,
  };
}
